import { BoxProps } from '@chakra-ui/react';

export const forgotPasswordContainerProps: BoxProps = {
  mt: '0',
};
